import { Skeleton } from "antd";
import * as React from "react";

import Layout from "./Layout";
import Helmet from "./Helmet";

const PageLoading = () => (
  <Layout>
    <Helmet title="Loading..." />
    <Skeleton active />
  </Layout>
);

export default PageLoading;
